import { createGlobalStyle } from 'styled-components';

import Gothic from '@/assets/fonts/gothic.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gothic';
    src: url(${Gothic});
  }   

  .generated-images-holder-var38 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var38 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }

  .right-text-holder-var38 {
    height: 100%;
    background-color: white;
    padding: 33px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &--reversed {
      order: -1;
    }
  }
  .right-text-var38 {
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    letter-spacing: -0.05em;
    line-height: 1.2;
    p {
      display: inline;
    }
  }
  .left-text-var38 {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 33px;
    width: 50%;
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    letter-spacing: -0.04em;
    line-height: 1.2;
    font-weight: 700;
     -webkit-text-shadow: 2.2px 0 0 #1C2327;
    -moz-text-shadow: 2.2px 0 0 #1C2327;
    -ms-text-shadow: 2.2px 0 0 #1C2327;
    -o-text-shadow: 2.2px 0 0 #1C2327;
    text-shadow: 2.2px 0 0 #1C2327;
    p {
      display: inline;
    }
  }
  .break-var38 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
`;

export default VariationsStyles;
